import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import StudentProgressView from "../components/student-progress/StudentProgressView";

const StudentProgress = () => {
  return (
    <AdminLayout>
      <StudentProgressView />
    </AdminLayout>
  );
};

export default StudentProgress;
